module.exports = __webpack_public_path__ + "img/walkthrough_illust31@2x.bd9781e0.png";